import { render } from "./AddManualJudge.vue?vue&type=template&id=310de34a"
import script from "./AddManualJudge.vue?vue&type=script&lang=js"
export * from "./AddManualJudge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__